import http from "../http-common";

class SubscriptionWarrantyService {
  getPublicSettings() {
    return http.get("/subscription-warranty/public-settings");
  }

  getMyEligible() {
    return http.get("/subscription-warranty/my-eligible");
  }

  createExtensionOrder(typingCourseId) {
    return http.post("/subscription-warranty/create-order", { typingCourseId });
  }

  confirmExtension(typingCourseId, orderId, paymentId, signature) {
    return http.post("/subscription-warranty/confirm", {
      typingCourseId,
      orderId,
      paymentId,
      signature,
    });
  }

  getAdminSettings() {
    return http.get("/admin/subscription-warranty/settings");
  }

  updateAdminSettings(payload) {
    return http.put("/admin/subscription-warranty/settings", payload);
  }
}

const subscriptionWarrantyService = new SubscriptionWarrantyService();
export default subscriptionWarrantyService;
